import React from "react";

import "./Spinner.css";

const spinner = (props) => <div className={"loader"} />;

export default spinner;
